import { z } from "zod";

export const accountSchema = z
	.object({
		name: z.string().min(1, { message: "Nome é obrigatório" }),
		email: z
			.string()
			.min(1, { message: "E-mail é obrigatório" })
			.email({ message: "Digite um e-mail válido" }),
		password: z
			.string()
			.min(8, { message: "A senha precisa de ao menos 8 caracteres" })
			.regex(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[\p{S}\p{P}\p{M}]).*$/u, {
				message:
					"A senha precisa ter número, letra maiúscula, letra minúscula e símbolo",
			}),
		confirmPassword: z.string(),
	})
	.refine((values) => values.password === values.confirmPassword, {
		message: "As senhas não coincidem",
		path: ["confirmPassword"],
	});

export type AccountFormValues = z.infer<typeof accountSchema>;
